/**
 * 디자인 토큰 정의
 * Tailwind 클래스명과 매핑하여 사용
 */

/* eslint-disable no-restricted-syntax */

// 색상 클래스 토큰 (Tailwind 클래스명)
export const COLOR_CLASSES = {
  // Primary
  primary: 'primary',
  primaryHover: 'primary-hover',
  primaryLight: 'primary-light',
  primaryDark: 'primary-dark',
  
  // 헤더 배경
  headerBg: 'headerBg',
  
  // 상태 색상
  danger: 'danger',
  dangerHover: 'danger-hover',
  dangerLight: 'danger-light',
  
  success: 'success',
  successHover: 'success-hover',
  successLight: 'success-light',
  
  warning: 'warning',
  warningHover: 'warning-hover',
  warningLight: 'warning-light',
  
  // 회색 계열
  gray50: 'gray-50',
  gray100: 'gray-100',
  gray200: 'gray-200',
  gray300: 'gray-300',
  gray400: 'gray-400',
  gray500: 'gray-500',
  gray600: 'gray-600',
  gray700: 'gray-700',
  gray800: 'gray-800',
  gray900: 'gray-900',
  
  // 특수 색상
  overlay: 'overlay',
  glassWhite: 'glass-white',
  glassBlack: 'glass-black',
};

// 디자인 토큰 - 여백 시스템
export const SPACING = {
  // 기본 여백 단위 (4px = 0.25rem)
  unit: 4,
  
  // 페이지 컨테이너 여백
  page: {
    mobile: 16,      // 1rem - 학습 분석 기준
    desktop: 16,     // 1rem - 학습 분석 기준
    large: 24        // 1.5rem - 큰 화면용
  },
  
  // 카드/섹션 내부 여백
  container: {
    xs: 8,           // 0.5rem - 매우 작은 여백
    sm: 12,          // 0.75rem - 작은 여백 (p-3)
    default: 16,     // 1rem - 기본 여백 (p-4)
    lg: 24,          // 1.5rem - 큰 여백 (p-6)
    xl: 32           // 2rem - 매우 큰 여백 (p-8)
  },
  
  // 요소 간 간격
  gap: {
    xs: 4,           // 0.25rem - 매우 작은 간격
    sm: 8,           // 0.5rem - 작은 간격 (gap-2, space-y-2)
    default: 16,     // 1rem - 기본 간격 (gap-4, space-y-4)
    lg: 24,          // 1.5rem - 큰 간격 (gap-6)
    xl: 32           // 2rem - 매우 큰 간격 (gap-8)
  },
  
  // 섹션 여백
  section: {
    title: 12,       // 0.75rem - 제목 하단 여백 (mb-3)
    content: 16,     // 1rem - 컨텐츠 간격
    divider: 24      // 1.5rem - 섹션 구분 여백
  }
};

// 브레이크포인트
export const BREAKPOINTS = {
  mobile: 768,     // 모바일 기준점 (768px 미만)
  tablet: 1024,    // 태블릿 기준점
  desktop: 1280    // 데스크톱 기준점
};

// 반응형 여백 계산 함수
export const getResponsiveSpacing = (mobile, desktop = mobile, large = desktop) => ({
  mobile,
  desktop, 
  large
});

// 학습 분석 기준 여백 세트
export const LEARNING_STATUS_SPACING = {
  page: getResponsiveSpacing(16, 16, 24),
  card: getResponsiveSpacing(12, 16, 16),
  gap: getResponsiveSpacing(16, 16, 24),
  list: getResponsiveSpacing(8, 8, 12)
};

// Tailwind CSS 클래스 매핑
export const SPACING_CLASSES = {
  page: {
    mobile: 'p-4',           // 16px
    desktop: 'p-4',          // 16px  
    large: 'p-6'             // 24px
  },
  container: {
    xs: 'p-2',               // 8px
    sm: 'p-3',               // 12px
    default: 'p-4',          // 16px
    lg: 'p-6',               // 24px
    xl: 'p-8'                // 32px
  },
  gap: {
    xs: 'gap-1 space-y-1',   // 4px
    sm: 'gap-2 space-y-2',   // 8px
    default: 'gap-4 space-y-4', // 16px
    lg: 'gap-6 space-y-6',   // 24px
    xl: 'gap-8 space-y-8'    // 32px
  }
};

// Hex 색상 값 토큰 (실제 색상 값)
export const HEX_COLORS = {
  primary: '#4ABC85',
  primaryHover: '#3DA575',
  primaryLight: '#5BC995',
  primaryDark: '#2A9A65',
  headerBg: '#231F20',
  danger: '#DC2626',
  dangerHover: '#B91C1C',
  dangerLight: '#EF4444',
  success: '#22C55E',
  successHover: '#16A34A',
  successLight: '#4ADE80',
  warning: '#FACC15',
  warningHover: '#EAB308',
  warningLight: '#FDE047',
  
  // 추가 색상 (차트 및 UI용)
  blue: '#3B82F6',
  orange: '#FF6B35',
  gray100: '#F3F4F6',
  gray200: '#E5E7EB', 
  gray300: '#D1D5DB',
  gray400: '#9CA3AF',
  gray500: '#6B7280',
  gray600: '#4B5563',
  gray700: '#374151',
  gray800: '#1F2937',
  lightGray: '#F0F0F0',
  veryLightGray: '#E0E0E0',
  mediumGray: '#A3A1A2',
  borderGray: '#CCCCCC',
  white: '#FFFFFF',
  
  // 결과맵 관련 색상
  resultMap: {
    correctHint: '#B7E4CE',    // 맞을 가능성 (연한 초록)
    wrongHint: '#FDCECE',      // 틀릴 가능성 (연한 빨강)
  },
  
  // 난이도별 색상 (Level 1~5)
  level: {
    1: '#E8F5E8', // 연한 녹색
    2: '#B8E6B8', // 밝은 녹색
    3: '#88D688', // 중간 녹색
    4: '#4ABC85', // 진한 녹색 (primary와 동일)
    5: '#2D7A4A'  // 매우 진한 녹색
  },
  
  // 녹색 계열 색상 팔레트
  green: {
    50: '#E8F5E8',
    100: '#C5F1D8',
    200: '#A2E4C1',
    300: '#7ED0A5',
    400: '#5BC995',
    500: '#4ABC85', // primary
    600: '#36916E',
    700: '#2D7A4A',
    800: '#1E5432',
    900: '#0F2E1B'
  }
};

// 난이도별 색상 배열 (Level 1~5)
export const DIFFICULTY_COLORS = [
  HEX_COLORS.level[1],
  HEX_COLORS.level[2], 
  HEX_COLORS.level[3],
  HEX_COLORS.level[4],
  HEX_COLORS.level[5]
];

// 녹색 계열 그라데이션 
export const LEVEL_GREEN_COLORS = [
  HEX_COLORS.green[600], // #36916E
  HEX_COLORS.primary,    // #4ABC85
  HEX_COLORS.green[300], // #7ED0A5
  HEX_COLORS.green[200], // #A2E4C1
  HEX_COLORS.green[100]  // #C5F1D8
];

export const DOMAIN_GREEN_COLORS = [
  HEX_COLORS.primary,    // #4ABC85
  HEX_COLORS.green[200]  // #A2E4C1
];

// CSS 변수 생성
export const CSS_VARIABLES = {
  '--spacing-unit': `${SPACING.unit}px`,
  '--spacing-page-mobile': `${SPACING.page.mobile}px`,
  '--spacing-page-desktop': `${SPACING.page.desktop}px`,
  '--spacing-page-large': `${SPACING.page.large}px`,
  '--spacing-container-xs': `${SPACING.container.xs}px`,
  '--spacing-container-sm': `${SPACING.container.sm}px`,
  '--spacing-container-default': `${SPACING.container.default}px`,
  '--spacing-container-lg': `${SPACING.container.lg}px`,
  '--spacing-container-xl': `${SPACING.container.xl}px`,
  '--spacing-gap-xs': `${SPACING.gap.xs}px`,
  '--spacing-gap-sm': `${SPACING.gap.sm}px`,
  '--spacing-gap-default': `${SPACING.gap.default}px`,
  '--spacing-gap-lg': `${SPACING.gap.lg}px`,
  '--spacing-gap-xl': `${SPACING.gap.xl}px`,
  '--spacing-section-title': `${SPACING.section.title}px`,
  '--spacing-section-content': `${SPACING.section.content}px`,
  '--spacing-section-divider': `${SPACING.section.divider}px`,
  '--breakpoint-mobile': `${BREAKPOINTS.mobile}px`,
  '--breakpoint-tablet': `${BREAKPOINTS.tablet}px`,
  '--breakpoint-desktop': `${BREAKPOINTS.desktop}px`
};

// 테두리 반경 토큰
export const RADIUS = {
  sm: 'rounded',
  md: 'rounded-3xl',
  lg: 'rounded-3xl',
  full: 'rounded-full',
};

// 그림자 토큰
export const SHADOW = {
  sm: 'shadow-sm',
  md: 'shadow',
  lg: 'shadow-lg',
  xl: 'shadow-xl',
};

// 폰트 크기 토큰
export const FONT_SIZE = {
  xs: 'text-xs',
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
  '2xl': 'text-2xl',
};

// 폰트 무게 토큰
export const FONT_WEIGHT = {
  normal: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
}; 